import { render, staticRenderFns } from "./InventoryPagePresets.vue?vue&type=template&id=2bbd4ca6"
import script from "./InventoryPagePresets.vue?vue&type=script&lang=js"
export * from "./InventoryPagePresets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports